import { Box, Heading, Loading, Message, Text } from 'ui'
import { EvaluateEmptyState } from 'pages/ReviewPage/Evaluate/EvaluateEmptyState'
import { useReviewEvaluateV2ContextValue } from '../context/ReviewEvaluateV2Provider'
import { FilterBar } from './FilterBar'
import { GroupedShiftList } from './GroupedShiftList'

export const ReviewEvaluateV2Main = () => {
  const {
    state: { groups, filters, queryState },
  } = useReviewEvaluateV2ContextValue()

  const hasActiveFilters = Boolean(
    filters.startDate ||
      filters.endDate ||
      filters.locationId ||
      filters.positionId ||
      filters.workerId
  )

  const hasShifts = groups.some((group) => group.shifts.length > 0)

  return (
    <Box mb={4}>
      <Heading level={2} mr={3}>
        Worker Review
      </Heading>
      <Text mb={3}>
        5 stars = Excellent, 4 stars = Good, 3 stars = OK, 2 stars = Needs
        improvement, 1 star = Unacceptable
      </Text>

      <FilterBar />

      {queryState.isError && queryState.errorMessage ? (
        <Message variant="error">{queryState.errorMessage}</Message>
      ) : null}

      {queryState.isLoading ? (
        <Loading />
      ) : hasShifts ? (
        <GroupedShiftList />
      ) : hasActiveFilters ? (
        <Message variant="info">No workers match these filters.</Message>
      ) : (
        <EvaluateEmptyState />
      )}
    </Box>
  )
}
